import consts from "@/consts"
// import {arraySplitIntoChunks} from "@/lib/lib";
import {getApiProps} from "@/lib/lib";

// Built on every call and never cached: the array is also changed in place (splice on delete,
// push on a single update, sort in a getter) and nothing tells a cached map that it has gone stale.
function getUnitsMsgsIndexMap(state) {
    return new Map(state.units_msgs.map((msg, i) => [msg.xid, i]))
}

export default {
    state: {
        units_msgs_index: [],
        units_msgs: [],
    },
    actions: {
        fetchLastUnitsMsgs({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                //ToDo ??
                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getUnitsMsgsIndex.find(i => (i.unitId == args.unitId && i.date == getters.getDateToday))
                //     if (!index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchLastUnitsMsgs', args, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchUnitsMsgsChanged', args, time: Date.now() / 1000})

                let params = getApiProps('units_msgs', {withAddress: 1, ...args})
                //if(!args.force) params.lastTimes = getters.getUnitsMsgsLastTimeByUnitIds
                delete params.unitId;delete params.last;
                this.$api.unitsmsgs.getLast(args.unitId, args.last, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeUnitsMsgs', response.data)
                            commit('storeTrack', response.data)
                            resolve(response)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchLastUnitsMsgs', args, inprogress: false})
                        dispatch('setLastCall', {name: 'fetchUnitsMsgsChanged', args, inprogress: false})
                    });
            })
        },
        fetchUnitsMsgs4Date({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.date) {
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getUnitsMsgsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                dispatch('setLastCall', {name: 'fetchUnitsMsgs4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastUnitsMsgs', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchUnitsMsgsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('units_msgs', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;
                this.$api.unitsmsgs.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeUnitsMsgs', response.data)
                            commit('storeTrack', response.data)
                            commit('setUnitsMsgsIndex', {...args, count: response.data.length})
                            if (!args.unitId && response.data.length) {
                                // debugger
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUnitsMsgs4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastUnitsMsgs', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchUnitsMsgsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchUnitsMsgs4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.unitId || !args.from || !args.to) {
                    return reject(false)
                }

                //if (args.unitId > 0 && !args.force) {
                //    let msgs = getters.getUnitsMsgs.find(t => (t.unit_id == args.unitId && t.time?.utc >= args.from && t.time?.utc <= args.to))
                //    if (msgs) {
                //        return resolve(true)
                //    }
                //}

                dispatch('setLastCall', {name: 'fetchUnitsMsgs4Period', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastUnitsMsgs', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchUnitsMsgsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('units_msgs', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;
                this.$api.unitsmsgs.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeUnitsMsgs', response.data)
                            commit('storeTrack', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUnitsMsgs4Period', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastUnitsMsgs', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchUnitsMsgsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchUnitsMsgsChanged({dispatch, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchLastUnitsMsgs', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchUnitsMsgsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            //delete args.date
            args.force = true
            return dispatch('fetchUnitsMsgs4Date', args)
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastUnitsMsgs', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchUnitsMsgsChanged', args, inprogress: false})
                });
        },

        reloadUnitsMsgs({commit, dispatch}, args) {
            commit('clearUnitsMsgs')
            return dispatch('fetchUnitsMsgs4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setUnitsMsgsIndex(state, params) {
            let i = state.units_msgs_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.units_msgs_index.push(Object.freeze({...params}))
            } else {
                state.units_msgs_index[i] = Object.freeze({...state.units_msgs_index[i], ...params})
            }
        },
        storeUnitsMsgs(state, nUnitsMsgs) {
            if (!state.units_msgs.length) {
                state.units_msgs = nUnitsMsgs.map(e => Object.freeze(e))
                return true
            }

            const indexByXid = getUnitsMsgsIndexMap(state)

            nUnitsMsgs.forEach(function (nUnitsMsg) {
                let i = indexByXid.has(nUnitsMsg.xid) ? indexByXid.get(nUnitsMsg.xid) : -1
                if (i < 0) {
                    indexByXid.set(nUnitsMsg.xid, state.units_msgs.length)
                    state.units_msgs.push(Object.freeze(nUnitsMsg))
                } else
                //if (state.units_msgs[i][changedField] != nUnitsMsg[changedField])
                {
                    // updateObjectByDiff(state.units_msgs[i], nUnitsMsg)
                    delete nUnitsMsg.xid
                    state.units_msgs[i] = Object.freeze({...state.units_msgs[i], ...nUnitsMsg})
                }
            })
        },
        clearUnitsMsgs(state, {unitId} = {}) {
            if (unitId) {
                state.units_msgs = state.units_msgs.filter(m => (m.unit_id || m.object_id) != unitId)
                state.units_msgs_index = state.units_msgs_index.filter(i => i.unitId != unitId)
            } else {
                state.units_msgs = [];
                state.units_msgs_index = [];
            }
        },
    },
    getters: {
        getUnitsMsgsIndex(state) {
            return state.units_msgs_index
        },
        getUnitsMsgs(state) {
            return state.units_msgs
        },
        getLastUnitMsgByUnitIds(state) {
            return state.units_msgs.reduce((msgs, msg) => {
                if (!msgs[msg.unit_id] || msgs[msg.unit_id] < msg.time.utc) msgs[msg.unit_id] = msg.time.utc
                return msgs
            }, {})
        },
    }
}
